module.exports = __webpack_public_path__ + "img/logo.de4f4dfb.png";